import { Navigate } from "react-router-dom";
import Button from "../components/Button";
import styles from "./Login.module.css";
import { flashAlert, popup, popupClose } from "../global_js";

function Login({ setAuthToken }) {
  const handleLogin = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    await fetch("/api/login", {
      method: "post",
      body: new URLSearchParams({
        username: formData.get("username"),
        password: formData.get("password"),
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return res;
        }
      })
      .then((data) => {
        if (data && data.token && data.token != 1) {
          const now = new Date();
          const userData = {
            token: data.token,
            user: data.user,
            isAdmin: data.isAdmin,
            location: data.locationId,
            userId: data.idUsers,
            expiry: now.getTime() + 3600000,
          };

          localStorage.setItem("userLogin", JSON.stringify(userData));
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("user", data.user);
          sessionStorage.setItem("location", data.locationId);
          sessionStorage.setItem("userId", data.idUsers);
          //setAuthToken(data.token);
          window.location.href = "/";
        } else if (data.token == 1) {
          throw new Error("Invalid username or password.");
        } else {
          throw new Error(data.statusText);
        }
      })
      .catch((error) => {
        flashAlert(error, "error");
      });
  };

  return (
    <main className={styles.main}>
      <section id="section">
        <form onSubmit={handleLogin} className={styles.loginForm}>
          <div className={styles.website}>
            <h1>Banquetscheduler</h1>
          </div>
          <div className={styles.logo}>
            <img src="/logo192.png" />
          </div>
          <div className={styles.loginFormBody}>
            <div className={styles.loginFormDiv}>
              <label htmlFor="">Username</label>
              <input type="text" name="username" id="username" />{" "}
            </div>
            <div className={styles.loginFormDiv}>
              <label htmlFor="">Password</label>
              <input type="password" name="password" id="password" />
            </div>
            <Button type="secondary">Login</Button>
          </div>
        </form>
      </section>
    </main>
  );
}

export default Login;
